<div class="progress-bar-wrapper">
  <div class="progress-bar-container">
    <div class="spinner-border"></div>

    <progressbar
      *ngIf="model"
      class="progress-bar-component"
      [max]="model.max"
      [animate]="model.animate"
      [value]="model.value"
      [type]="model.type"
    >
      <b>{{ getPercentage() }}%</b>
    </progressbar>
    <small *ngIf="model" class="progress-bar-info-text">{{
      model.extraInfo
    }}</small>
  </div>
</div>
